import { memo } from "react";

import { AccessSection } from "./access-section";
import { FacilityBasicInfo } from "./basic-info";
import { HotelInfoSection } from "./hotel-info-section";
import { NotesSection } from "./notes-section";
import { ServiceGridSection } from "./service-grid-section";

/**
 * FacilityInfo: 施設詳細ブロック（ラッパ）
 *
 * ゲスト側 app/frontend/guest/_shared/src/components/facility-info/FacilityInfo.astro と
 * ページ [lang]/index.astro の外枠（space-y-16 rounded-xl bg-white p-5 tablet:px-8 tablet:py-10）を再現。
 * 3 グループ × 5 セクション構造を維持する。
 */

type Props = {
	hotelName: string;
};

export const FacilityInfo = memo(({ hotelName }: Props) => {
	return (
		<section className="space-y-16 rounded-xl bg-white p-5 tablet:px-8 tablet:py-10">
			<div className="flex flex-col gap-14">
				{/* グループ 1: 施設の基本 */}
				<div className="space-y-8">
					<FacilityBasicInfo name={hotelName} email="info@example.com" tel="03-1234-5678" />
					<AccessSection />
				</div>

				{/* グループ 2: 利用条件 */}
				<div className="space-y-8">
					<NotesSection />
					<ServiceGridSection />
				</div>

				{/* グループ 3: 詳細情報 */}
				<HotelInfoSection />
			</div>
		</section>
	);
});

FacilityInfo.displayName = "FacilityInfo";
